<template>
  <div class="order-main-status">
    <v-avatar :size="40" class="grey lighten-3 supplier__avatar">
      <img
        class="lazyload"
        :src="order.supplier_avatar"
        v-img-fallback="'/assets/images/supplier_avatar.png'"
        alt="avatar"
      />
      <SvgIcon
        v-if="order.returning_status_label"
        class="supplier___return-status"
        height="20"
        width="20"
        :icon="order.returning_status_label.returned ? 'AttachedReturned' : 'AttachedReturning'"
      />
    </v-avatar>
    <div class="order-main-status__content">
      <span v-dompurify-html="frontLabel"></span>
      <span data-test-id="supplier_name" class="supplier__name"
        >{{ order.supplier_name }}&nbsp;</span
      >
      <span class="supplier__rating" v-if="order.supplier_rating > 0">
        <vue-numeric
          v-bind:precision="1"
          v-model="order.supplier_rating"
          read-only
          data-test-id="supplier_star"
        />
        <SvgIcon class="star-icon" height="12" width="12" icon="StarSelected" />
      </span>
      <span class="supplier__delivery-status" v-dompurify-html="backLabel"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderMainStatus',
  props: {
    order: {
      type: Object
    },
    frontLabel: {
      type: String
    },
    backLabel: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.order-main-status {
  padding: 16px 16px 12px;
  display: flex;
  align-items: center;

  .supplier__avatar {
    margin-right: 12px;
    position: relative;

    .supplier___return-status {
      position: absolute;
      bottom: -4px;
      right: -5px;
    }
  }

  .order-main-status__content {
    flex: 1;
    line-height: 20px;

    .supplier__name {
      font-weight: 500;
      margin-left: 4px;
    }

    .supplier__rating {
      padding: 4px 8px;
      margin: 0 4px;
      background-color: #f2f2f2;
      border-radius: 26px;
      font-weight: 500;
      font-size: 13px;
      white-space: nowrap;

      .star-icon {
        margin-left: 4px;
        display: inline-block;
      }
    }
  }
}
</style>

<style lang="scss">
.supplier__delivery-status {
  color: #7a8189;

  > span {
    color: #1a1a1a;
    font-weight: 500;
  }
}
</style>
